import {
  AtlasContextFieldSettings,
  AtlasContextFieldValues
} from '@secca/shared/models/atlas/atlas-chatbot.model';

export const DEFAULT_ATLAS_CONTEXT_FIELD_SETTINGS: AtlasContextFieldSettings = {
  customerProfile: true,
  productName: true,
  insurancePeriodFrom: true,
  insurancePeriodTo: true,
  reporter: false,
  endUserNationality: true,
  winterSportEnabled: true,
  incidentLocation: true,
  incidentCauseLevel1: true,
  incidentCauseLevel2: true,
  incidentCauseLevel3: true,
  incidentDescription: true,
  mainDiagnosis: true,
  departureDate: true,
  arrivalDate: true,
  travelDestination: true,
  coTravellers: false,
  purposeOfTravel: true,
  incidentDate: true
};

export const ATLAS_CONTEXT_FIELD_LABELS: { [key in keyof AtlasContextFieldSettings]: string } = {
  customerProfile: 'Customer Profile',
  productName: 'Product Name',
  insurancePeriodFrom: 'Insurance Period From',
  insurancePeriodTo: 'Insurance Period To',
  reporter: 'Reporter',
  endUserNationality: 'End-user Nationality',
  winterSportEnabled: 'Winter Sport Enabled',
  incidentLocation: 'Incident Location',
  incidentCauseLevel1: 'Incident Cause Level 1',
  incidentCauseLevel2: 'Incident Cause Level 2',
  incidentCauseLevel3: 'Incident Cause Level 3',
  incidentDescription: 'Incident Description',
  mainDiagnosis: 'Main Diagnosis',
  departureDate: 'Departure Date',
  arrivalDate: 'Arrival Date',
  travelDestination: 'Destinations',
  coTravellers: 'Co-travellers',
  purposeOfTravel: 'Purpose of Travel',
  incidentDate: 'Incident Date'
};

export const ALWAYS_ENABLED_WHEN_AVAILABLE_CONTEXT_FIELDS: (keyof AtlasContextFieldSettings)[] = [
  'customerProfile',
  'productName'
];

export function normalizeContextFieldSettings(
  settings: Partial<AtlasContextFieldSettings> | null
): AtlasContextFieldSettings {
  return {
    ...DEFAULT_ATLAS_CONTEXT_FIELD_SETTINGS,
    ...(settings || {})
  };
}

export function getEnabledContextFieldLabels(settings: AtlasContextFieldSettings): string[] {
  return (Object.keys(ATLAS_CONTEXT_FIELD_LABELS) as (keyof AtlasContextFieldSettings)[])
    .filter(key => settings[key])
    .map(key => ATLAS_CONTEXT_FIELD_LABELS[key]);
}

export function enforceContextFieldAvailability(
  settings: AtlasContextFieldSettings,
  values: AtlasContextFieldValues
): AtlasContextFieldSettings {
  const nextSettings = { ...settings };
  (Object.keys(nextSettings) as (keyof AtlasContextFieldSettings)[]).forEach(key => {
    if (!hasContextValue(values[key])) {
      nextSettings[key] = false;
    }
  });
  ALWAYS_ENABLED_WHEN_AVAILABLE_CONTEXT_FIELDS.forEach(key => {
    if (hasContextValue(values[key])) {
      nextSettings[key] = true;
    }
  });
  return nextSettings;
}

export function hasContextValue(value: string | null): boolean {
  return !!(value && value.trim());
}
